import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type { CreateProductRequestDto } from "../../dtos/create-product-request-dto";
import type { CreateProductResponseDto } from "../../dtos/create-product-response-dto";
import { ProductService } from "../../services/product-service";

type UsePostCreateProductMutationParams = {
  options?: UseMutationOptions<
    CreateProductResponseDto,
    unknown,
    CreateProductRequestDto
  >;
};

export const usePostCreateProductMutation = ({
  options
}: UsePostCreateProductMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.createProduct({ payload });
    },
    ...options
  });
};
